import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'audit-ring',
  styleUrls: ['../audit-theme.css'],
  template: `
    <svg
      [attr.viewBox]="'0 0 ' + size + ' ' + size"
      [attr.width]="size"
      [attr.height]="size"
      style="display:block"
    >
      <circle
        class="wa-ring-track"
        [attr.cx]="size / 2"
        [attr.cy]="size / 2"
        [attr.r]="r"
        fill="none"
        [attr.stroke-width]="stroke"
      ></circle>
      <circle
        [attr.cx]="size / 2"
        [attr.cy]="size / 2"
        [attr.r]="r"
        fill="none"
        [attr.stroke]="color"
        [attr.stroke-width]="stroke"
        [attr.stroke-dasharray]="circumference"
        [attr.stroke-dashoffset]="dashoffset"
        stroke-linecap="round"
        [attr.transform]="'rotate(-90 ' + size / 2 + ' ' + size / 2 + ')'"
      ></circle>
      <text
        [attr.x]="size / 2"
        [attr.y]="size / 2"
        text-anchor="middle"
        dominant-baseline="central"
        [attr.fill]="color"
        [attr.font-size]="fontSize"
        font-weight="500"
      >
        {{ displayLabel }}
      </text>
    </svg>
  `,
})
export class AuditRingComponent implements OnChanges {
  @Input() value = 0;
  @Input() color = '#6161ff';
  @Input() size = 96;
  @Input() stroke = 8;
  @Input() fontSize = 18;
  @Input() label?: string;

  r = 0;
  circumference = 0;
  dashoffset = 0;
  displayLabel = '';

  ngOnChanges(): void {
    const v = Math.max(0, Math.min(100, this.value || 0));
    this.r = (this.size - this.stroke) / 2;
    this.circumference = 2 * Math.PI * this.r;
    this.dashoffset = this.circumference * (1 - v / 100);
    this.displayLabel = this.label !== undefined ? this.label : `${Math.round(v)}`;
  }
}
